const s = require("./api.module.scss");

import { default as React, useEffect, useContext, useState } from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import { ApplicationState } from "core/app";
import * as queryString from "querystring";

interface OwnState {
    url: string;
    applicationState: ApplicationState;
    method: string;
    data: any;
}

type PageProps = OwnState & WithTranslation;

const Page = ({ t, url, applicationState, method, data }: PageProps) => {

    return <div style={{ overflowWrap: "break-word" }}>
        {method == "POST" ?
            <div>
                <div className="inputlabel">Curl</div>
                curl -X POST "{url}"
                ^<br />
                {/*-H "Authorization: Bearer {(applicationState.userRole === "Guest" ? "***Enter Your Personal Token Here***" : applicationState.userToken)}"
                ^<br />*/}
                -H "Content-Type: application/json;charset=UTF-8"
                ^<br />
                -d "{JSON.stringify(data).replace(/\"/g, "\\\"")}"
            </div>
            :
            <div>
                <div className="inputlabel">Curl</div>
                curl -X {method} "{url}{data}"
                {/*^<br />
                -H "Authorization: Bearer {(applicationState.userRole === "Guest" ? "***Enter Your Personal Token Here***" : applicationState.userToken)}"*/}
            </div>
        }</div>;
};

export default withTranslation()(Page);
